import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import {
	MAT_DIALOG_DATA,
	MatDialogRef,
	MatDialogTitle,
	MatDialogContent,
	MatDialogActions,
} from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatLabel } from '@angular/material/input';
import { MatButton } from '@angular/material/button';

/**
 * @deprecated This component is deprecated and will be removed in a future version.
 * Please use lmc-dialog component instead.
 */
@Component({
	selector: 'common-dialog',
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: 'common-dialog.html',
	imports: [
		MatDialogTitle,
		CdkScrollable,
		MatDialogContent,
		MatLabel,
		MatDialogActions,
		MatButton,
	],
})
export class CommonDialog {
	readonly dialogRef = inject(MatDialogRef<CommonDialog>);
	readonly data = inject<DialogData>(MAT_DIALOG_DATA);

	onDismiss(result: boolean): void {
		this.dialogRef.close(result);
	}
}

export interface DialogData {
	title: string;
	content: string;
}
